import React from 'react'
// libs
import get from 'lodash/get'
// components
import { Modal } from 'components/UI'
// view components
import EditActivityForm from 'components/Modals/EditActivityModal/Form'
// constants
import { Modals } from 'constants/index'
// hooks
import { useModalData } from 'hooks/index'
// types
import { LogEntityTypes } from 'types/graphql'
// utils
import { handleError } from 'utils/errors/handlers'

const PAPER_PROPS = {
  style: {
    margin: 0,
    overflow: 'auto',
    position: 'fixed' as any,
    width: 400,
    height: 245
  }
}

const EditActivityModal: React.FC = () => {
  const {
    hideModal,
    modalData: { width, isOpen, handleConfirm, activity }
  } = useModalData({ modalType: Modals.EDIT_ACTIVITY_MODAL })

  const handleFormSubmit = async (data) => {
    try {
      await handleConfirm(data)
      hideModal()
    } catch (errors) {
      handleError(errors, 'EditActivityModal.handleFormSubmit')
    }
  }

  let initialValues

  if (get(activity, 'entityType') === LogEntityTypes.Link) {
    initialValues = {
      linkTarget: get(activity, 'metadata.fileUrl'),
      linkName: get(activity, 'metadata.fileName')
    }
  } else {
    initialValues = { attachmentName: get(activity, 'metadata.fileName') }
  }

  return (
    <Modal
      hideBackdrop
      width={width}
      isOpen={isOpen}
      disableBackdropClick
      disableEscapeKeyDown
      PaperProps={PAPER_PROPS}>
      <EditActivityForm
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        activity={activity}
        hideModal={hideModal}
      />
    </Modal>
  )
}

export default EditActivityModal
